@if (svc.alertas().length > 0) {
  <div class="ai-notif-centro">
    @for (a of svc.alertas(); track a.id) {
      <div class="ai-notif-item" [class.is-lido]="!!a.lidoEm">
        <div class="ai-notif-texto">
          <span class="ai-notif-titulo">{{ a.titulo }}</span>
          <span class="ai-notif-mensagem">{{ a.mensagem }}</span>
        </div>
        <one-check-chip size="xs" [label]="a.perguntaSugerida" (toggled)="escolherAlerta(a)" />
        <button class="ai-notif-dispensar" type="button" (click)="dispensarAlertaCentro(a.id, $event)" aria-label="Dispensar aviso">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>
}

<div class="ai-conversa" #conversa (scroll)="onScrollConversa($event)">
  @for (m of svc.mensagens(); track $index) {
    <div class="ai-msg" [class.is-user]="m.role === 'user'">
      <div class="ai-bolha">
        @for (seg of segmentos(m.texto); track $index) {
          @if (seg.tipo === 'link') {
            <a [href]="seg.href" target="_blank" rel="noopener noreferrer">{{ seg.texto }}</a>
          } @else if (seg.tipo === 'negrito') {
            <strong>{{ seg.texto }}</strong>
          } @else {
            <span>{{ seg.texto }}</span>
          }
        }

        @if (m.role === 'assistant' && m.fontes?.length) {
          <div class="ai-fontes">
            <span class="ai-fontes-titulo">Fontes (pesquisado na internet):</span>
            <ul>
              @for (f of m.fontes!; track f.uri) {
                <li><a [href]="f.uri" target="_blank" rel="noopener noreferrer">{{ f.titulo }}</a></li>
              }
            </ul>
          </div>
        }

        @if (m.role === 'assistant' && $last && guia.trechoAtual() && !tourRoteiro.ativo()) {
          <one-check-chip size="sm" icon="tour" label="Ver no tour desta tela"
                          data-test="chip-tour-tela" (toggled)="guia.executar('tour-tela')" />
        }

        @if (m.role === 'assistant' && alvosDe(m); as alvos) {
          <one-check-chip size="sm" icon="my_location" label="Ver na tela"
                          data-test="chip-ver-na-tela" (toggled)="verNaTela(alvos)" />
        }

        @if (m.hora) {
          <span class="ai-hora">{{ m.hora }}</span>
        }
      </div>

      @if (m.opcoes?.length) {
        <div class="ai-chips">
          @for (o of m.opcoes!; track o.id) {
            <one-check-chip size="sm" [label]="o.rotulo" (toggled)="escolher(o)" />
          }
        </div>
      }

      @if (m.confirmToken) {
        <div class="ai-confirm">
          <one-button variant="primary" size="sm" (clicked)="confirmar(m.confirmToken!)">Confirmar</one-button>
          <one-button variant="text" size="sm" (clicked)="svc.fechar()">Cancelar</one-button>
        </div>
      }

      @if (m.resultados; as r) {
        <div class="ai-resultados">
          <div class="ai-resultados-cabecalho">{{ r.titulo || 'Resultados' }} · {{ r.total }}</div>
          @for (it of r.itens; track it.id) {
            <button class="ai-resultado-item" type="button" (click)="abrirItem(it)">
              <span class="ai-resultado-titulo">{{ it.titulo }}</span>
              @if (it.subtitulo) { <span class="ai-resultado-sub">{{ it.subtitulo }}</span> }
            </button>
          }
          @if (r.rotaUi && r.total > r.itens.length) {
            <button class="ai-ver-todos" type="button" (click)="verTodos(r)">Ver todos ({{ r.total }})</button>
          }
        </div>
      }
    </div>
  }

  @if (compacto() && svc.estado() === 'pensando') {
    <div class="ai-thinking" aria-live="polite">
      <span class="ai-thinking-dots"><i></i><i></i><i></i></span>
      <span class="ai-thinking-label">{{ svc.progresso() || 'pensando' }}</span>
    </div>
  }

  <!-- Aviso efêmero (ex.: áudio sem voz): só na tela — nunca entra no histórico da IA. -->
  @if (svc.avisoEfemero(); as aviso) {
    <div class="ai-aviso-efemero" role="status">{{ aviso }}</div>
  }
</div>

<guia-chips />

<!-- Barra de input estilo WhatsApp: pílula de texto + 1 botão redondo à direita que alterna
     mic (campo vazio) → enviar (com texto). Gravando, a barra vira lixeira + timer + enviar. -->
<form class="ai-input" (submit)="enviar($event)">
  @if (!gravando()) {
    <div class="ai-input-pill">
      <input #inputTexto [ngModel]="texto()" (ngModelChange)="texto.set($event)"
             name="texto" [ngModelOptions]="{ standalone: true }"
             placeholder="Mensagem" autocomplete="off" />
    </div>
    @if (texto().trim()) {
      <button type="submit" class="ai-btn-principal" [disabled]="svc.ocupado()" aria-label="Enviar">
        <mat-icon>send</mat-icon>
      </button>
    } @else {
      <button type="button" class="ai-btn-principal" [disabled]="svc.ocupado()" (click)="alternarMic()"
              aria-label="Gravar áudio">
        <mat-icon>mic</mat-icon>
      </button>
    }
  } @else {
    <button type="button" class="ai-rec-lixeira" (click)="cancelarGravacao()" aria-label="Cancelar gravação">
      <mat-icon>delete</mat-icon>
    </button>
    <span class="ai-rec-dot" aria-hidden="true"></span>
    <span class="ai-rec-timer">{{ tempoGravacao() }}</span>
    <span class="ai-ondas" aria-hidden="true">
      @for (v of ondas(); track $index) {
        <i [style.height.px]="3 + v * 21"></i>
      }
    </span>
    <button type="button" class="ai-btn-principal" (click)="finalizarGravacao()" aria-label="Enviar áudio">
      <mat-icon>send</mat-icon>
    </button>
  }
</form>

<p class="ai-disclaimer">O Assistente é uma IA e pode cometer erros. Confira informações importantes.</p>
